import styled from "styled-components"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    min-height: 85vh;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Label = styled.span`
    font-size: var(--fontM);
`

export const Error = styled.p`
    color: var(--secondary);
`